<!--设备属性编辑界面-->
<template>
  <div class="archiverstype">
    <div class="con">
      <div class="left-tree">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        <div class="btns">
          <el-button type="primary" size="mini" @click="addSuperiorShow=true,addType='同级'">新增同级</el-button>
          <el-button type="primary" size="mini" @click="newAddSuperior">新增子级</el-button>
        </div>
        <el-scrollbar style="height:calc(100% - 60px);width: 100%;">
          <el-tree :data="getEntityTypeList"  :expand-on-click-node="true" node-key="id"
            :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree"
            @node-click="checkItem">
            <span class="custom-tree-node" slot-scope="{node}">
              <img v-if="node.data.typeEnum == 0" src="../../../public/static/image/elTree/2.0.png" />
              <img v-else src="../../../public/static/image/elTree/variable.png" />
              <span style="padding:0px  5px;">{{node.data.typeName }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="right-table">
        <div class="top-table">
          <div class="Files-top">
            <div class="ic-left">
              <span>设备详情</span>
            </div>
            <div class="btns"></div>
          </div>
          <el-table :data="treeTableList" height="100" stripe style="width: 100%;margin-top: 10px;" border>
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column type="index" width="50" align="center" label="序号">
            </el-table-column>
            <el-table-column prop="mainTypeId" label="上级类型编码" align="center" min-width="350">
            </el-table-column>
            <el-table-column prop="typeCode" label="类型编码" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="typeName" label="类型名称" align="center" min-width="200">
            </el-table-column>
            <el-table-column prop="editable" label="是否可编辑" :formatter="formatEditable" align="center" min-width="150">
            </el-table-column>
            <el-table-column label="操作" width='250' prop='editable' align="center" fixed="right">
              <template #default="{row}">
                <div class="public-flex">
                  <div @click="editSuperior(row)" class="mr-20">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                      <elIconBtn btnType='edit'></elIconBtn>
                    </el-tooltip>
                  </div>
                  <div @click="deleteArchives('上级',row)">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                      <elIconBtn btnType='del'></elIconBtn>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom-table">
          <div class="Files-top">
            <div class="ic-left">
              <span>设备属性</span>
            </div>
            <div class="btns"><el-button type="primary" @click='addPropertyShow=true' class="last-el-button"
                :disabled='typeEnum == 0'>添加属性</el-button></div>
          </div>
          <div class="search-input-btn" style="width:100%">
            <div class="input-small">
              <span>名称：</span>
              <el-input v-model="search" clearable placeholder="请输入名称"></el-input>
            </div>
            <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
          </div>
          <div class="my-table">
            <el-table :data="attributesList" :height="heights" stripe style="width: 100%;margin-top: 10px;" border>
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column type="index" width="50" align="center" label="序号">
              </el-table-column>
              <el-table-column prop="propertyName" label="属性名称" align="center">
              </el-table-column>
              <el-table-column prop="propertyName" label="属性等级" align="center">
                 <template #default="{row}">
                    <span v-if="row.propertyGrade == 1">1-事故</span>
                    <span v-if="row.propertyGrade == 2">2-异常</span>
                    <span v-if="row.propertyGrade == 4">4-变位</span>
                    <span v-if="row.propertyGrade == 5">5-告知</span>
                 </template>
              </el-table-column>
             
              <el-table-column label="操作" width='180' align="center" fixed="right">
                <template #default="{row}">
                  <div class="public-flex">
                    <div @click="editClick(row)" class="mr-20">
                      <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                        <elIconBtn btnType='edit'></elIconBtn>
                      </el-tooltip>
                    </div>
                    <div @click="deleteArchives('属性',row)">
                      <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <elIconBtn btnType='del'></elIconBtn>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>


      </div>
      <el-dialog title="编辑设备" :visible.sync="editSuperiorShow">
        <el-form :model="editSuperiorForm">
          <el-form-item label="设备名称" label-width="120px">
            <el-input v-model="editSuperiorForm.typeName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="是否为目录" label-width="120px" prop="editable">
            <el-radio v-model="editSuperiorForm.typeEnum" label="0">是</el-radio>
            <el-radio v-model="editSuperiorForm.typeEnum" label="1">否</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editSuperiorShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmSuperiorForm()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="编辑属性" :visible.sync="propertyShow">
        <el-form :model="editPropertyForm" :rules="editRules" ref="editPropertyForm">
          <el-form-item label="属性名称" label-width="120px" prop="propertyName">
            <el-input v-model="editPropertyForm.propertyName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
           <el-form-item label="属性等级" label-width="120px" prop="propertyGrade">
                <el-select v-model="editPropertyForm.propertyGrade" placeholder="请选择">
                  <el-option label="1-事故" :value="'1'"></el-option>
                  <el-option label="2-异常" :value="'2'"></el-option>
                  <el-option label="4-变位" :value="'4'"></el-option>
                  <el-option label="5-告知" :value="'5'"></el-option>
                </el-select>
          </el-form-item>
        </el-form>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="propertyShow = false">取 消</el-button>
          <el-button type="primary" @click="editPropertyConfirm()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加设备" :visible.sync="addSuperiorShow">
        <el-form :model="addSuperiorForm" :rules="addRules">
          <el-form-item label="设备名称" label-width="120px">
            <el-input v-model="addSuperiorForm.typeName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="设备编码" label-width="120px">
            <el-input v-model="addSuperiorForm.typeCode" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
         
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addSuperiorShow = false">取 消</el-button>
          <el-button type="primary" @click="addConfirm">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加属性" :visible.sync="addPropertyShow">
        <el-form :model="addPropertyForm" :rules="rules" ref="addPropertyForm">
          <el-form-item label="属性名称" label-width="120px" prop="propertyName">
            <el-input v-model="addPropertyForm.propertyName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="属性等级" label-width="120px" prop="propertyGrade">
                <el-select v-model="addPropertyForm.propertyGrade" placeholder="请选择">
                  <el-option label="1-事故" :value="'1'"></el-option>
                  <el-option label="2-异常" :value="'2'"></el-option>
                  <el-option label="4-变位" :value="'4'"></el-option>
                  <el-option label="5-告知" :value="'5'"></el-option>
                </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addPropertyShow = false">取 消</el-button>
          <el-button type="primary" @click="addPropertyConfirm()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/javascript">
  import {getDeviceTree,createEntityType,updateEntityType,deleteEntityType,getAllByEntityTypeCode,insertMisTypeProperty,updateMisTypeProperty,deleteMisTypeProperty} from "../../api/dataComparisonApi";
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {
      elIconBtn
    },
    props: [],
    data () {
      return {
        heights:  Math.round((document.getElementById('app').clientHeight) * 0.55),
        defaultProps: {
          children: 'children',
          label: 'typeName'
        },
        filterText: "",
        treeList: [],
        treeTableList: [],
        attributesList: [],
        editSuperiorShow: false, //编辑上级类型
        editSuperiorForm: {
          date: '',
          typeCode: '',
          typeName: '',
          editable: '',
          typeEnum: ''
          // isRank: '',
        },
        propertyShow: false,
        editPropertyForm: {
          propertyName: '',
           propertyGrade:""
          
        },
        addSuperiorShow: false,
        addSuperiorForm: {
          typeName: '',
          typeCode: '',
          typeEnum: "0"
          // isRank: '0'
        },
        addType: '', //添加的类型
        addPropertyShow: false,
        addPropertyForm: {
          propertyName: '',
          propertyGrade:""
        },
        search: '',
        getEntityTypeList: [], //树数据
        rules: {
          propertyName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          propertyGrade: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          
          typeCode: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          defaultValue: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
        },
        addRules: {
          typeName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          typeCode: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],

        },
        editRules: {
          propertyName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          typeCode: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          valueType: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          defaultValue: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          editable: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          isOnly: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          nullable: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
        },
        isShow: true,
        typeEnum: 0,
        attributesListCopy: []

      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      this.getLeftTree()
    },
    destroyed () {},
    computed: {
      getValueEnum () {
        return this.$store.archivesStore.state.valueEnum
      },
      atrStyle () {
        let width='100%'
        if(this.isShow) {
          width='calc(100% - 2.26rem)'
        }
        return {
          "width": width
        }
      }
    },
    watch: {},
    methods: {
      //获取左边树形结构
      getLeftTree(){
        getDeviceTree().then(res => {
            this.getEntityTypeList = res.data
        })
      },
      //左边树形结构点击
       checkItem (data) {
        this.treeTableList=[data]
        this.typeEnum=data.typeEnum
        
        if(data.typeEnum!=0) {
           this.initData(data.typeId)
        } else {
          this.attributesList=[]
        }
      },
      //新增设备
       addConfirm () {
        if(this.addSuperiorForm.typeName=="") {
          this.$message({message: '设备名称不能为空！',type: 'warning'})
          return
        }
        if(this.addSuperiorForm.typeCode=="") {
          this.$message({message: '设备编码不能为空！',type: 'warning'})
          return
        }
        //确认添加上级或者同级
        if(this.addType=='同级') {
          //添加同级
          var d = {
            'mainTypeId':this.treeTableList[0].mainTypeId,
            'typeCode':this.addSuperiorForm.typeCode,
            'typeName':this.addSuperiorForm.typeName,
          }
          createEntityType(d).then(res => {
            
             if(res.code == 200){
              this.getLeftTree()
               this.$message({ message: '添加成功', type: 'success' })
                this.addSuperiorShow=false
             }else {
               res.message ? this.$message.error(res.message) : this.$message.error('添加失败');
             }
          })
        } else {
            //添加子级
          var d = {
            'mainTypeId':this.treeTableList[0].typeId,
            'typeCode':this.addSuperiorForm.typeCode,
            'typeName':this.addSuperiorForm.typeName,
          }
          createEntityType(d).then(res => {
             if(res.code == 200){
              this.getLeftTree()
               this.$message({ message: '添加成功', type: 'success' })
                this.addSuperiorShow=false
             }else {
               res.message ? this.$message.error(res.message) : this.$message.error('添加失败');
             }
          })
        }
       
      },
      //修改
      confirmSuperiorForm () {
        if(this.editSuperiorForm.typeName=="") {
          this.$message({message: '设备名称不能为空！',type: 'warning'})
          return
        }

        var d = {
            "editable": this.treeTableList[0].editable,
            "mainTypeId": this.treeTableList[0].mainTypeId,
            "typeCode": this.treeTableList[0].typeCode,
            "typeEnum": this.editSuperiorForm.typeEnum,
            "typeId": this.treeTableList[0].typeId,
            "typeName": this.editSuperiorForm.typeName
          }
        updateEntityType(d).then(res => {
             if(res.code == 200){
              this.getLeftTree()
              this.$message({message: '修改成功',type: 'success'})
              this.treeTableList[0].typeName = this.editSuperiorForm.typeName
              this.editSuperiorShow=false
             }else {
               res.message ? this.$message.error(res.message) : this.$message.error('修改失败');
             }
        })

        
       
      },
      //删除
      deleteArchives (type,item) {
        var tipStr = ""
        if(type == '上级'){
         tipStr = '此操作将永久删除该设备, 是否继续?'
        }else {
           tipStr = '此操作将永久删除该设备属性, 是否继续?'
        }
        //删除台账
        this.$confirm(tipStr,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type=='上级') {
             deleteEntityType({'typeId':item.typeId}).then(res => {
              if(res.code == 200){
              this.getLeftTree()
               this.$message({ type: 'success',  message: '删除成功!' });
              this.treeTableList = []
             }else {
               res.message ? this.$message.error(res.message) : this.$message.error('删除失败');
             }
             })
          } else {
            deleteMisTypeProperty({'propertyId':item.id}).then(res => {
               if(res.code == 200){
               this.$message({message: '删除成功',type: 'success'})
               this.initData(this.treeTableList[0].typeId)
              }else {
                res.message ? this.$message.error(res.message) : this.$message.error('删除失败');
              }
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //根据设备查询属性
      initData (myid) {
        getAllByEntityTypeCode({'entityTypeId':myid}).then(res => {
            if(res.code == 200){
               this.attributesList=res.data
               this.attributesListCopy=copy(res.data)
             }else {
               res.message ? this.$message.error(res.message) : this.$message.error('查询属性失败！！');
             }
        })
      },
      //添加设备属性
      addPropertyConfirm () {
         var d  = {
            'entityTypeId':this.treeTableList[0].typeId,
            'propertyName':this.addPropertyForm.propertyName,
            'propertyGrade':this.addPropertyForm.propertyGrade,
         }
         insertMisTypeProperty(d).then(res => {
              if(res.code == 200){
               this.$message({message: '添加成功',type: 'success'})
               this.initData(this.treeTableList[0].typeId)
               this.addPropertyShow = false
              }else {
                res.message ? this.$message.error(res.message) : this.$message.error('添加失败！！');
              }
         })
      },
      //打开属性编辑弹窗
       editClick (item) {
        this.editPropertyForm=copy(item)
        this.propertyShow=true
      },
      //修改设备属性
      editPropertyConfirm(){
        var d = {
            'entityTypeId':this.editPropertyForm.entityTypeId,
            'id':this.editPropertyForm.id,
            'propertyGrade':this.editPropertyForm.propertyGrade,
            'propertyName':this.editPropertyForm.propertyName,
        }
         updateMisTypeProperty(d).then(res => {
            if(res.code == 200){
               this.$message({message: '修改成功',type: 'success'})
               this.initData(this.treeTableList[0].typeId)
               this.propertyShow = false
              }else {
                res.message ? this.$message.error(res.message) : this.$message.error('修改失败！！');
              }
         })
      },
        //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.typeName.indexOf(value)!==-1;
      },
        search_fn () {
        this.attributesList=this.attributesListCopy.filter(data => !this.search||data.propertyName.toLowerCase().includes(this.search.toLowerCase()))
      },



      //旧
    
    
      //编辑上级类型-赋值
      editSuperior (val) {
        console.log("val",val);
        this.editSuperiorShow=true
        this.editSuperiorForm=copy(val)
        this.editSuperiorForm.typeEnum=copy(val.typeEnum.toString())
      },
      
      getEntityList () {
        //获取树数据
        this.$api.entityApi.getEntityTypeList(respon => {
          if(!isempty(respon)) {
            this.getEntityTypeList=deviceList(respon)
          }

        })
      },
     
      //新添加子级
      newAddSuperior () {
        if(this.typeEnum==1) {
          this.$message({message: '请先修改此项为有子级，否则不能添加子级',type: 'warning'})
          return
        }
        this.addSuperiorShow=true
        this.addType='子级'
      },
      
      
     
     
      
      isEdit (value) {
        return value==0? false:true
      },
      //格式化内容
      formatEditable (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        return row.editable===1? '是':'否'
      },
      formatValueType (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        if(!isempty(this.$store.archivesStore.state.valueEnum[row.valueType])) {
          return this.$store.archivesStore.state.valueEnum[row.valueType].text
        }
      },
      formatterIsOnly (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        return row.isOnly===1? '是':'否'
      },
      formatterNullable (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        return row.nullable===1? '是':'否'
      }
    }
  }
</script>

<style scoped lang="scss">
  .archiverstype {
    .con {
      width: 100%;
      height: 100%;
      // background-color: #fff;
      box-sizing: border-box;
      display: flex;

      .left-tree {
        width: 300px;
        height: 100%;
        background-color: #fff;
        margin-right: 8px;
        padding: 12px;
        box-sizing: border-box;

        .btns {
          margin-top: 12px;
          margin-bottom: 5px;
        }

        /deep/.el-button {
          padding: 6px 11px !important;
        }
      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .right-table {
        width: calc(100% - 308px);
        height: 100%;

        .top-table {
          width: 100%;
          height: 170px;
          background-color: #fff;
          padding: 12px 20px;
          box-sizing: border-box;
          margin-bottom: 8px;
        }

        .bottom-table {
          width: 100%;
          height: calc(100% - 178px);
          background-color: #fff;
          box-sizing: border-box;
          padding: 12px 20px;
        }
      }
    }
  }
</style>